import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";

import {
  FaUserEdit,
  FaFileUpload,
  FaComments,
  FaRobot,
  FaNotesMedical,
  FaInfoCircle,
  FaHandsHelping
} from "react-icons/fa";

const UserHome = () => {
  const navigate = useNavigate();
  const patientID = localStorage.getItem("patientID");

  const [groupName, setGroupName] = useState("Loading group...");
  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/patient/group/${patientID}`
        );
        setGroupName(res.data.groupName);
      } catch {
        setGroupName("Your Care Group");
      }
    };

    if (patientID) fetchGroup();
  }, [patientID]);

  return (
    <>
     
      <div style={layout}>
        <aside style={sidebar}>
          <h2 style={logo}>User Page</h2>

          <div style={navItem} onClick={() => navigate("/patientProfileEdit")}>
            <FaUserEdit /> Edit Profile
          </div>

          <div style={navItem}>
            <FaFileUpload /> Upload Documents
          </div>

          <div style={navItem} onClick={() => navigate("/patientmap")}>
            <FaHandsHelping /> Uber Care
          </div>

          <div style={navItem}>
            <FaComments /> ElderChat
          </div>

          <div style={navItem} onClick={() => navigate("/agents")}>
            <FaRobot /> Agents
          </div>

          <div style={navItem}>
            <FaNotesMedical /> Care Logs
          </div>
        </aside>

        <main style={content}>
          <h1 style={{ marginBottom: "6px" }}>Welcome 👋</h1>

          <div style={groupBadge}>
            You are part of <strong>{groupName}</strong>
          </div>

          <p style={subtitle}>
            This is your personal care space. Everything here is connected to your group.
          </p>

          <div style={cards}>
            <div
              style={{ ...infoCard, cursor: "pointer" }}
              onClick={() => navigate("/patientProfileEdit")}
            >
              <FaUserEdit size={22} color="#0E5580" />
              <h3>Edit Profile</h3>
              <p style={cardText}>
                Keep your personal and medical information up to date.
              </p>
            </div>

            <div
              style={{ ...infoCard, cursor: "pointer" }}
              onClick={() => navigate("/patientmap")}
            >
              <FaHandsHelping size={22} color="#198754" />
              <h3>Uber Care</h3>
              <p style={cardText}>
                Find available caregivers connected to your group.
              </p>
            </div>

            <div style={{ ...infoCard, cursor: "pointer" }} onClick={() => navigate("/agents")}>
              <FaRobot size={22} color="#6f42c1" />
              <h3>Agents</h3>
              <p style={cardText}>
                Import and manage conversational agents configured for your profile.
              </p>
            </div>

            <div style={infoCard}>
              <FaComments size={22} color="#6f42c1" />
              <h3>ElderChat</h3>
              <p style={cardText}>
                Communicate with caregivers and family in your circle.
              </p>
            </div>
          </div>

          <div style={infoBox}>
            <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaInfoCircle /> Helpful Information
            </h3>

            <ul style={tips}>
              <li>All actions here apply to your care group.</li>
              <li>Use Uber Care to find help when needed.</li>
              <li>Keeping your profile updated improves assistance.</li>
            </ul>
          </div>
        </main>
      </div>
    </>
  );
};

export default UserHome;

/* =====================
   STYLES
===================== */

const layout = {
  display: "flex",
  height: "100vh",
  background: "#f4f6f8"
};

const sidebar = {
  width: "260px",
  background: "#0E5580",
  color: "#fff",
  padding: "30px 20px",
  display: "flex",
  flexDirection: "column"
};

const logo = {
  marginBottom: "40px",
  fontSize: "22px",
  fontWeight: "bold"
};

const navItem = {
  padding: "14px 16px",
  marginBottom: "12px",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "15px",
  background: "rgba(255,255,255,0.1)"
};

const content = {
  flex: 1,
  padding: "40px",
  overflowY: "auto"
};

const groupBadge = {
  display: "inline-block",
  background: "#eef5ff",
  color: "#0E5580",
  padding: "6px 14px",
  borderRadius: "999px",
  fontSize: "18px",
  marginBottom: "14px"
};

const subtitle = {
  color: "#555",
  marginBottom: "30px"
};

const cards = {
  display: "flex",
  gap: "20px",
  marginBottom: "30px",
  flexWrap: "wrap"
};

const infoCard = {
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  width: "240px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
};

const cardText = {
  fontSize: "14px",
  color: "#555",
  marginTop: "8px"
};

const infoBox = {
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
};

const tips = {
  marginTop: "12px",
  paddingLeft: "18px",
  color: "#555",
  lineHeight: "1.6"
};



